import ajaxProxy from '../globs/ajax-proxy';

export const ADD_FEEDBACK_PENDING = 'add-feedback_PENDING';
export const ADD_FEEDBACK_FULFILLED = 'add-feedback_FULFILLED';
export const ADD_FEEDBACK_REJECTED = 'add-feedback_REJECTED';

export default function addComplaintFeedback(
  targetUrl,
  feedback,
) {
  return (dispatch) => {
    dispatch(addFeedbackPeding());
    ajaxProxy
    .addComplaintFeedback(
      feedback,
      targetUrl,
    )
    .then((response) => {
      dispatch(addFeedbackFulfilled(response));
    })
    .catch((error) => {
      dispatch(addFeedbackRejected(error));
    });
  };
}

function addFeedbackPeding() {
  return {
    type: ADD_FEEDBACK_PENDING,
    payload: {},
  };
}

function addFeedbackFulfilled(res) {
  return {
    type: ADD_FEEDBACK_FULFILLED,
    payload: res,
  };
}

function addFeedbackRejected(err) {
  return {
    type: ADD_FEEDBACK_REJECTED,
    payload: err,
  };
}
